import { useState } from "react";
import { BellRing, Send } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { errMsg } from "@/lib/api";
import { DENIED, enablePrintPush, notifyState, testPrintPush } from "@/lib/printPush";

const LABEL = {
  granted: ["Ativos neste computador", "text-emerald-600"],
  denied: ["Bloqueados no navegador", "text-destructive"],
  default: ["Ainda não ativados", "text-amber-600"],
  unsupported: ["Este navegador não aceita avisos", "text-muted-foreground"],
};

export function PrintPushBox({ central }) {
  const [state, setState] = useState(notifyState);
  const [busy, setBusy] = useState(false);
  const act = (fn, ok) => async () => {
    setBusy(true);
    try { await fn(); toast.success(ok); } catch (e) { toast.error(e?.response ? errMsg(e) : e.message); } finally { setState(notifyState()); setBusy(false); }
  };
  const [label, cls] = LABEL[state];
  return (
    <div className="space-y-2 rounded-lg border p-3 text-sm" data-testid="print-push-box">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <span className="flex items-center gap-2 font-medium"><BellRing className="h-4 w-4 shrink-0" />Avisos com o sistema minimizado:<span className={cls} data-testid="print-push-status">{label}</span></span>
        {state === "granted" && <Button size="sm" variant="outline" disabled={busy} onClick={act(() => testPrintPush(central), "Aviso de teste enviado. Minimize esta janela para ver a notificação.")} data-testid="print-push-test-btn"><Send className="h-4 w-4 mr-1" />Enviar teste</Button>}
        {state === "default" && <Button size="sm" disabled={busy} onClick={act(() => enablePrintPush(central), "Avisos ativados neste computador")} data-testid="print-push-enable-btn"><BellRing className="h-4 w-4 mr-1" />Ativar avisos</Button>}
      </div>
      {state === "denied" && <p className="text-xs text-destructive" data-testid="print-push-denied">{DENIED}</p>}
      <p className="text-xs text-muted-foreground">
        Cada pedido novo gera um aviso no Windows; se não sair sozinho, o aviso traz o botão <b>Imprimir agora</b>. Deixe o Chrome ou Edge aberto (pode minimizar), desligue o <b>Não perturbe</b> do Windows e
        permita as notificações do navegador em Configurações do Windows → Sistema → Notificações. Se o Chrome estiver com <b>Economia de memória</b>, em Configurações → Desempenho adicione este site em "Sempre manter estes sites ativos".
      </p>
    </div>
  );
}
